export default {
    title: 'Complispace Primary',
    viewTitle: 'Complispace Primary',
    showSideNav: true,
    showSearchPanel: false,
    snackBar: {
        timeout: 5000,
        text: null,
        showCloseButton: true
    },
    alert: {
        type: null,
        message: null
    },
    theme: {
        primary: 'blue-grey darken-2',
        accent: 'blue-grey accent-2',
        secondary: 'blue-grey darken-2',
        info: 'blue',
        warning: 'amber',
        error: 'red',
        success: 'green'
    },
    cursor: 'default',
    isFullScreen: false,
    isPreferencesView: false,
    characterLimitLine: 2,
    isMobile: false
};



// WEBPACK FOOTER //
// ./src/store/modules/appearance/defaultState.js